import { render, staticRenderFns } from "./PurchaseGroupArray.vue?vue&type=template&id=91a263e2"
import script from "./PurchaseGroupArray.vue?vue&type=script&lang=js"
export * from "./PurchaseGroupArray.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports